import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/communication/notifications")({
	component: Outlet,
	staticData: {
		crumb: {
			label: "Notifications",
		},
	},
});
